import React from 'react';

import { Layer, Source } from 'react-map-gl';
import { selectedPathSection } from '../../mapStyles';



const sectionStyle = selectedPathSection();


export const FeaturePathLine = ({feature}) => {
  return (
    <Source key='selectedsection' id='selectedsection' type='geojson' data={feature}>
      <Layer key='selectedsection' id='selectedsection' {...sectionStyle} />
    </Source>
  );
};